import React from 'react';
import { useForm } from 'react-hook-form';
import { AuthContextType } from '../../../features/auth/AuthContext';
import { retrieveUserProfile, updateUserProfile } from '../../../api/account';

/*
사용자 프로필을 수정하는 양식

데이터베이스 테이블은 user_profile 이며 django의 user 모델과 1:1로 연결되어 있음.

주요 정보로는

- 업체명(bus_name)
- 연락처(phone_number)
- 담당자 또는 대표자 등 연락처 구분이 필요한데 한 사용자에 여러 연락처가 있는 케이스라,
  관계형 디비를 만들거나 아니면 contacts 와 같은 json 필드로 만드는 방법을 고려 중
- 사업자 정보 (사업자번호, 대표자명, 사업자등록일)가 있지만 사용자 verify 용
- 어쨌든 수정 가능하게 해야 함

*/

interface UserProfileInput {
    phone_number: string;
    bus_name: string; // models.CharField(max_length=100, null=True, blank=True)  # busniess name
    bus_num: string;  // models.CharField(max_length=10, null=True, blank=True)  # 123-45-67890
    bus_started_at: string; // models.CharField(max_length=8, null=True, blank=True)  # 20251231
    bus_address: string; // models.TextField(null=True, blank=True)
    rep_name: string; // models.CharField(max_length=100, null=True, blank=True)  # representative name
}

interface UserProfileFormProps {
    auth: AuthContextType;
}

const UserProfileForm: React.FC<UserProfileFormProps> = ({ auth }) => {
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
    const [processMessage, setProcessMessage] = React.useState<string | null>(null);
    const [successMessage, setSuccessMessage] = React.useState<string | null>(null);

    const { register, handleSubmit, reset } = useForm<UserProfileInput>({
        defaultValues: {
            bus_name: '',
            phone_number: '',
            bus_num: '',
            bus_started_at: '',
            bus_address: '',
            rep_name: '',
        },
    });

    React.useEffect(() => {
        retrieveUserProfile({
            auth,
            setErrorMessage,
            setResult: (data: UserProfileInput) => {
                reset({
                    bus_name: data?.bus_name || '',
                    phone_number: data?.phone_number || '',
                    bus_num: data?.bus_num || '',
                    bus_started_at: data?.bus_started_at || '',
                    bus_address: data?.bus_address || '',
                    rep_name: data?.rep_name || '',
                });
            },
        });
    }, [auth, reset]);

    const onSubmit = (data: UserProfileInput) => {
        setErrorMessage(null);
        setSuccessMessage(null);
        updateUserProfile({
            auth,
            payload: {
                bus_name: data.bus_name,
                phone_number: data.phone_number,
                bus_num: data.bus_num,
                bus_started_at: data.bus_started_at,
                bus_address: data.bus_address,
                rep_name: data.rep_name,
            },
            setErrorMessage,
            setProcessMessage,
            setSuccessMessage,
        });
    };

    return (<>
        {errorMessage && (
            <div className="alert alert-danger" role="alert">
                {errorMessage}
            </div>
        )}
        {processMessage && (
            <div className="alert alert-info" role="alert">
                {processMessage}
            </div>
        )}
        {successMessage && (
            <div className="alert alert-success" role="alert">
                {successMessage}
            </div>
        )}

        <div className="col-6">
            <ul className="list-unstyled">
                <li className="mb-3">
                    <label className="form-label">업체명</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('bus_name')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">전화번호</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('phone_number')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">사업자등록번호</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('bus_num')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">사업개시일</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('bus_started_at')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">사업장 주소</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('bus_address')}
                    />
                </li>
                <li className="mb-3">
                    <label className="form-label">대표자명</label>
                    <input
                        type="text"
                        className="form-control"
                        {...register('rep_name')}
                    />
                </li>
            </ul>
            <div className="d-flex gap-2">
                <button type="button" className="btn btn-primary" onClick={handleSubmit(onSubmit)}>
                    저장
                </button>
            </div>
        </div>
    </>)
}

export default UserProfileForm;
